import React from 'react';
import { Icon } from './Icon.js';
export const IconChartLine = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M2.5 15.7102L9.06666 9.14357L14.9333 14.8579L21.5 8.29119", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconChartLine.js.map